import {getUserAgent} from '@/utils/user-agent'
import {axios, handleResponse} from '@/api/axios.js'
import appConfig from '@/config'
import Cookie from 'js-cookie'

function _normoalize (options, opts) {
  let method = options.method.toUpperCase()
  let token = Cookie.get(appConfig.cookie.TOKEN)
  let request
  // 携带token
  if (token) {
    if (!options.headers) options.headers = {}
    options.headers[appConfig.headers.TOKEN] = token
  }
  // 携带UA
  let userAgent = getUserAgent()
  if (userAgent) {
    if (!options.headers) options.headers = {}
    options.headers[appConfig.headers.USER_AGENT] = encodeURIComponent(userAgent)
  }
  switch (method) {
    case 'GET':
      request = () => {
        return axios.get(options.path, {
          headers: options.headers,
          params: options.params,
          timeout: appConfig.timeout,
          ...opts
        }).then(res => handleResponse(res))
      }
      break
    case 'POST':
      request = async () => {
        return handleResponse(await axios.post(options.path,
          options.params,
          {
            headers: options.headers,
            timeout: appConfig.timeout
          })
        )
      }
      break
    case 'PUT':
      request = async () => {
        return handleResponse(await axios.put(options.path,
          options.params,
          {
            headers: options.headers,
            timeout: appConfig.timeout
          })
        )
      }
      break
    case 'DELETE':
      request = async () => {
        return handleResponse(await axios.delete(options.path, {
          headers: options.headers,
          timeout: appConfig.timeout,
          params: options.params
        }))
      }
  }
  return request
}

const request = (config) => {
  return (name, params = null, headers = {}, opts = {}) => { // append: ''
    if (typeof name !== 'string') throw new Error('name参数必须为字符串')
    if (!name || !name.trim()) throw new Error('name不能为空')
    let names = name.split('/')
    let namespace = names[0]
    let nameParam = names[1]
    let api = config[namespace]
    for (let i = 0; i < api.length; ++i) {
      let item = api[i]
      if (item.name === nameParam) {
        let options = {}
        for (let key in item) {
          if (item.hasOwnProperty(key)) {
            options[key] = item[key]
          }
        }
        options.path = item.mock ? item.mockPath : item.path
        if (item.append) options.path += '/' + opts.append
        options.params = !params ? item.params : params
        return _normoalize(options, opts)
      }
    }
    throw new Error(`没有找到相应的接口：${namespace} => ${nameParam}.`)
  }
}

export default request



// WEBPACK FOOTER //
// ./src/api/request.js